module.exports = __webpack_public_path__ + "img/8455919.png";